import mawgifLogo from '@/assets/img/images.png'
import HeadingComponent from '../shared/heading';

export const TableCurrentMonthYear = ({ title, subtitle = "", columns, rows, isCFO = false }) => {
  return (
    <div className="px-2">
      <div className="flex flex-col gap-1 mb-5">
        {
          title && <HeadingComponent variant={isCFO ? "cfo" : "main"}>
            {title}
          </HeadingComponent>
        }
        {
          subtitle && <HeadingComponent variant={isCFO ? "cfoSub" : "sub"}>
            {subtitle}
          </HeadingComponent>
        }
      </div>

      {/* Table wrapper */}
      <div
        style={{
          overflowX: "auto",
          border: "1px solid black",
          borderRadius: "0px",
          backgroundColor: "white", // bg-dark
        }}
        
      >
        <table
          style={{
            width: "100%",
            tableLayout: "fixed",
            fontSize: "0.525rem",
            borderCollapse: "collapse",
            minWidth: "980px",
          }}
        >
          <thead
            style={{ fontSize: "0.4375rem" }}
            className="[&>tr:last-child>th]:border-b-2 [&>tr:last-child>th]:border-black"
          >
            {/* Row 1 */}
            <tr>
              <th
                rowSpan={3}
                style={{
                  width: "112px",
                  borderRight: "1px solid black",
                  backgroundColor: "white",
                  padding: "3px",
                  borderBottom: "1px solid black",
                }}
              >
                <img
                  src={mawgifLogo}
                  alt="Logo"
                  style={{
                    width: "100%",
                    height: "35px",
                    objectFit: "cover",

                  }}
                />
              </th>

              {[0, 4, 8, 12].map((start, sectionIndex) =>
                columns.slice(start, start + 4).map((col, idx) => (
                  <th
                    key={`${sectionIndex}-${idx}`}
                    style={{
                      borderLeft:
                        idx === 0 ? "1px solid black" : "1px solid #bfbfbf",
                      borderRight: "1px solid #bfbfbf",
                      borderTop: "1px solid #bfbfbf",
                      borderBottom: "1px solid #bfbfbf",
                    }}
                    className={`text-[8px] ${col.isYTD
                      ? "bg-table-header-column-navyBlue text-white"
                      : "bg-table-header-column-purple text-black"
                      }`}
                  >
                    {col.year}
                  </th>
                ))
              )}
            </tr>

            {/* Row 2 */}
            <tr>
              {[0, 4, 8, 12].map((start, sectionIndex) =>
                columns.slice(start, start + 4).map((col, idx) => (
                  <th
                    key={`p-${sectionIndex}-${idx}`}
                    style={{
                      borderLeft: "1px solid black",
                      borderRight: "1px solid #bfbfbf",
                      borderTop: "1px solid #bfbfbf",
                      borderBottom: "1px solid #bfbfbf",
                    }}
                    className={`text-[8px] ${col.isYTD
                      ? "bg-table-header-column-navyBlue text-white"
                      : "bg-table-header-column-purple text-black"
                      }`}
                  >
                    {col.period}
                  </th>
                ))
              )}
            </tr>

            {/* Row 3 (BOTTOM — BLACK BORDER) */}
            <tr>
              {[0, 4, 8, 12].map((start, sectionIndex) =>
                columns.slice(start, start + 4).map((col, idx) => (
                  <th
                    key={`t-${sectionIndex}-${idx}`}
                    style={{
                      borderLeft: "1px solid black",
                      borderRight: "1px solid #bfbfbf",
                      borderTop: "1px solid #bfbfbf",
                      borderBottom: "1px solid black", // 👈 important
                    }}
                    className={`text-[8px] ${col.isYTD
                      ? "bg-table-header-column-navyBlue text-white"
                      : "bg-table-header-column-purple text-black"
                      }`}
                  >
                    {col.type}
                  </th>
                ))
              )}
            </tr>
          </thead>

          <tbody>
            {rows.map((row, rowIndex) => {
              const lightGrayLabels = [
                "NET PROFIT MARGIN",
                "Rent V Revenue %",
                "Staff Cost-Direct %",
                "EBITDA Margin"

              ];

              // Determine border styles for each row
              const getRowBorderStyle = (rowLabel) => {
                // Revenue section borders
                if (rowLabel === "Revenue") {
                  return {
                    borderTop: "1px solid black",
                    borderBottom: "1px solid #bfbfbf"
                  };
                }
                if (rowLabel === "Total Revenue" || rowLabel === "Zakat, Exceptional & CG") {
                  return {
                    borderTop: "1px solid #bfbfbf",
                    borderBottom: "3px solid black"
                  };
                }

                // Expense & EBITDA section borders
                if (rowLabel === "Total Rent") {
                  return {
                    borderTop: "1px solid black",
                    borderBottom: "1px solid #bfbfbf"
                  };
                }
                if (rowLabel === "EBITDA") {
                  return {
                    borderTop: "1px solid #bfbfbf",
                    borderBottom: "1px solid #bfbfbf"
                  };
                }

                // Profitability section borders
                if (rowLabel === "OPERATING PROFIT/(LOSS)") {
                  return {
                    borderTop: "1px solid black",
                    borderBottom: "1px solid #bfbfbf"
                  };
                }
                if (rowLabel === "NET PROFIT MARGIN") {
                  return {
                    borderTop: "1px solid #bfbfbf",
                    borderBottom: "1px solid black"
                  };
                }

                // Default borders
                return {
                  borderTop: "1px solid #bfbfbf",
                  borderBottom: "1px solid #bfbfbf"
                };
              };
              const isBoldRow = (label) => {
                return [
                  "Total Revenue",
                  "EBITDA",
                  "EBITDA MARGIN",
                  "OPERATING PROFIT/(LOSS)",
                  "NET PROFIT MARGIN",
                  "EBITDA Margin"
                ].includes(label);
              };

              const rowBorderStyle = getRowBorderStyle(row.label);

              return <tr
                key={rowIndex}
                style={{
                  ...rowBorderStyle
                }}
              >
                <td
                  style={{
                    fontWeight: isBoldRow(row.label) ? 700 : 400,
                     color: "black",
                    padding: "2px",
                    paddingLeft: "7px",
                    borderLeft: "3px solid black",
                    borderRight: "1px solid #bfbfbf",
                    borderTop: "1px solid #bfbfbf",
                    borderBottom: "1px solid #bfbfbf"
                  }}
                  className={`!border !border-1 !border-table-border-light   !border-r-black   ${row.isTotal ? "text-black bg-table-row-column-yellow" : row.isSectionHeader ? "text-black bg-white" : "text-black bg-table-row-column-skyBlue"} ${lightGrayLabels.includes(row.label) ? "!bg-table-row-column-lightGray" : ""}`}>
                  {row?.label}
                </td>

                {row.values.map((value, colIndex) => {
                  let cellStyle = {
                    textAlign: "right",
                    padding: "1px",
                    borderLeft: "1px solid #bfbfbf",
                    borderRight: colIndex === row.values.length - 1 ? "3px solid black" : "1px solid #bfbfbf",
                    borderTop: "1px solid #bfbfbf",
                    borderBottom: "1px solid #bfbfbf",
                    color: "black",
                    fontWeight: isBoldRow(row.label)  && value !== "-"? 700 : 400
                  };

                  // Add thick vertical borders for section separators
                  if (colIndex === 3 || colIndex === 7 || colIndex === 11) {
                    cellStyle.borderRight = "1px solid black";
                  }

                  const isNegative = typeof value === "string" && value.startsWith("(");

                  if (isNegative) {
                    cellStyle.color = "var(--table-row-text-red)";
                  }

                  if (row?.label) {
                    cellStyle.backgroundColor = "var(--table-row-column-orange)";
                  }
                  if (row?.label === "Revenue") {
                    cellStyle.backgroundColor = "white";
                  }

                  const grayBgLabels = [
                    "Total Revenue",
                    "Total Rent",
                    "Total Staff Cost - Direct",
                    "Total Other Direct",
                    "OPERATING PROFIT/(LOSS)",
                    "Total Depreciation & Amortization",
                    "Zakat, Exceptional & CG, !border border-b-black"
                  ];

                  if (grayBgLabels.includes(row?.label)) {
                    cellStyle.backgroundColor = "var(--table-row-column-gray)";
                  }

                  if (row?.label === "EBITDA") {
                    cellStyle.backgroundColor = "var(--table-header-column-purple)";
                  }

                  return (
                    <td key={colIndex} style={cellStyle} className="!border !border-1 border-black text-[10px] font-medium overflow-hidden">
                      {value || "-"}
                    </td>
                  );
                })}
              </tr>
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}